<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Add Document</h4>
                        <h6 class="card-subtitle">Upload a new document and save</h6>
                    </div>
                    <hr>

                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body form-group row">
                            <div class="col-md-12 upload-form form-group">
                                <div class="form-group row">
                                    <label class="control-label col-md-2">Title</label>
                                    <div class="col-md-10 text-left">
                                        <input :class="{'is-invalid': submitted && errors.has('title')}"
                                               class="form-control"
                                               data-vv-as="Audit Name"
                                               id="title"
                                               name="title"
                                               type="text"
                                               v-model="title"
                                               v-validate="'required'">
                                        <div class="invalid-feedback" v-if="submitted && errors.has('title')">{{
                                            errors.first('title') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="control-label col-md-2">About</label>
                                    <div class="col-md-10 text-left">
                                                        <textarea class="form-control"
                                                                  id="desc"
                                                                  name="desc"
                                                                  placeholder="Description"
                                                                  rows=4
                                                                  type="text"
                                                                  v-model="description">
                                                        </textarea>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="control-label col-md-2">Browse & Upload</label>
                                    <div class="col-md-10 text-left">
                                        <div class="input-group mb-1">
                                            <div class="custom-file">
                                                <input :class="{'is-invalid': submitted && errors.has('file')}"
                                                       accept=".pdf,.jpeg,.jpg,.png,.webp"
                                                       class="custom-file-input"
                                                       data-vv-as="Attachment"
                                                       id="file" name="file"
                                                       ref="file"
                                                       type="file"
                                                       v-on:change="onFileChange()"
                                                       v-validate="'required'">
                                                <label class="custom-file-label text-ellipsis">{{filename}}</label>
                                            </div>
                                        </div>
                                        <div class="invalid-feedback" v-if="submitted && errors.has('file')">{{
                                            errors.first('file') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="resetAttachment()"
                                            class="btn waves-effect waves-light btn-secondary"
                                            type="button">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import uuid from "uuid/v4";
    import {mapGetters} from "vuex";

    export default {
        name: "AddMyCredential",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                certifications: [],
                submitted: false,
                file: null,
                filename: "Choose File",
                error: [],
                title: null,
                description: null,
                attachment: null
            }
        },
        methods: {
            async onFileChange() {
                this.file = this.$refs.file.files[0];
                this.filename = this.file.name;
            },
            async uploadFile() {
                try {
                    this.uploadstatus = "Uploading File Please Wait";
                    let signedurl = await this.getUploadUrl();
                    await axios.put(signedurl, this.file);
                } catch (e) {

                }
            },
            async getUploadUrl() {
                let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/signedurl`, {
                    params: {
                        name: this.filename,
                        type: 'write'
                    }
                });

                let parts = this.filename.split(".");
                this.attachment = {
                    id: uuid(),
                    name: this.filename,
                    title: this.title,
                    description: this.description,
                    url: data.key,
                    content_type: parts[parts.length - 1]
                };

                return data.url;
            },
            async handleSubmit(e) {
                this.submitted = true;
                try {
                    let valid = await this.$validator.validate();
                    if (valid) {
                        this.submitted = false;
                        await this.uploadFile();
                        await this.storeAttachment()
                    }
                } catch (e) {
                    console.error(e);
                }
            },
            resetAttachment() {
                this.file = File;
                this.filename = "Upload Attachment";
                this.title = "";
                this.description = "";
            },
            async storeAttachment() {
                try {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/attachments`, this.attachment);
                    this.$toastr('success', 'Attachment added successfully.', 'Success');
                    this.resetAttachment();
                    await this.$router.push({name: 'my-credentials'})
                } catch (e) {

                }
            }
        }
    }
</script>

<style scoped>

</style>
